/**
 * Copy-count rules, kept out of the component so they can be unit-tested and so
 * the file exporting <CopiesField/> exports only a component (Fast Refresh).
 */
export const MIN_COPIES = 1;

/** The server's own ceiling (OptionPriceRequest.copies: le=100). */
export const MAX_COPIES = 100;

export function clampCopies(value: number): number {
  if (!Number.isFinite(value)) return MIN_COPIES;
  return Math.min(MAX_COPIES, Math.max(MIN_COPIES, Math.round(value)));
}

/** Parses `?c=` — junk, zero and negatives all fall back to one copy. */
export function parseCopies(raw: string | undefined): number {
  if (!raw) return MIN_COPIES;
  const parsed = Number.parseInt(raw, 10);
  return Number.isNaN(parsed) ? MIN_COPIES : clampCopies(parsed);
}
